/**
 * Author : wang885298.
 * Date   : 2019/6/13.
 * File   : ygst.
 */
import { schoolviewGet } from '@/api/SchoolView'

const state = {
  supplier: {},
  viewObj: {},
  viewList:
    {
      'e001': '1',
      'e002': '1',
      'e003': '1',
      'e004': '1',
      'e005': '1'
    }
}
const mutations = {
  SET_SUPPLIER(state, supplier) {
    state.supplier = supplier
  },
  SET_VIEW_OBJ(state, viewObj) {
    state.viewObj = viewObj
  },
  SET_VIEW_LIST(state, viewList) {
    state.viewList = viewList
  }
}
const actions = {
  setSupplier({commit}, supplier) {
    commit('SET_SUPPLIER', supplier)
  },
  setViewObj({commit}, viewObj) {
    commit('SET_VIEW_OBJ', viewObj)
  },
  setViewList({commit}, orgId) {
    return new Promise((resolve, reject) => {
      schoolviewGet({
        orgId
      }).then(res => {
        commit('SET_VIEW_LIST', res)
        console.log('SET_VIEW_LIST', res)
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ygst.js